import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridComponent } from './grid.component';
import {GridRoutingModule} from './grid-routing.module';
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import { LicenseManager } from  'ag-grid-enterprise';
import {CodemirrorModule} from '@ctrl/ngx-codemirror';
import {SharedModule} from '../shared/shared.module';
import { ObsoleteComponent } from './dialogs/obsolete/obsolete.component';
import {FeedComponent} from './dialogs/feed/feed.component';
import { ExpressionsBuilderDialogComponent } from './dialogs/expressions-builder-dialog/expressions-builder-dialog.component';
import { CellEditorBrandComponent } from './cell-editors/cell-editor-brand/cell-editor-brand.component';
import { CellEditorTypeComponent } from './cell-editors/cell-editor-type/cell-editor-type.component';
import { CellEditorTagsComponent } from './cell-editors/cell-editor-tags/cell-editor-tags.component';
import { BulkEditDialogComponent } from './dialogs/bulk-edit-dialog/bulk-edit-dialog.component';
import { ExportDiaglogComponent } from './dialogs/export-diaglog/export-diaglog.component';
import { ImportDiaglogComponent } from './dialogs/import-diaglog/import-diaglog.component';
import {ProgressBarsComponent} from '../components/progress-bars/progress-bars.component';
import { FeedToolPanelComponent } from './components/feed-tool-panel/feed-tool-panel.component';
import {MatDividerModule} from '@angular/material/divider';
import { GridLogsComponent } from './grid-logs/grid-logs.component';
import { LogsToolPanelComponent } from './components/logs-tool-panel/logs-tool-panel.component';
import {MatTreeModule} from '@angular/material/tree';
import {MatRippleModule} from '@angular/material/core';
import { ConfirmationCellComponent } from './components/confirmation-cell/confirmation-cell.component';
import { GridProductionComponent } from './grid-production/grid-production.component';
import { GridHistoryComponent } from './grid-history/grid-history.component';
import { DateComponentComponent } from './components/date-component/date-component.component';
import { HistoryDialogComponent } from './dialogs/history-dialog/history-dialog.component';
import { CellHistoryRestoreButtonComponent } from './cell-editors/cell-history-restore-button/cell-history-restore-button.component';
import { SkuComponent } from './cell/sku/sku.component';
import { AdminToolPanelComponent } from './components/admin-tool-panel/admin-tool-panel.component';
import { CellEditorAsmTagsComponent } from './cell/cell-editor-asm-tags/cell-editor-asm-tags.component';
import { TagsFilterComponent } from './filters/tags-filter/tags-filter.component';
import { GridDuplicatesComponent } from './grid-duplicates/grid-duplicates.component';
import { CellEditorShippingTagsComponent } from './cell-editors/cell-editor-shipping-tags/cell-editor-shipping-tags.component';
import { CellEditorRelatedProductsComponent } from './cell-editors/cell-editor-related-products/cell-editor-related-products.component';
import { CellEditorDatasheetComponent } from './cell-editors/cell-editor-datasheet/cell-editor-datasheet.component';
import { StatusCellComponent } from './cell/status-cell/status-cell.component';
import {UserManagementComponent} from '../admin/user-management/user-management.component';
import { GridDeleteProductsComponent } from './grid-delete-products/grid-delete-products.component';
import { TagsCustomFilterComponent } from './filter/tags-custom-filter/tags-custom-filter.component';
import { CellEditorVendorTagsComponent } from './cell-editors/cell-editor-vendor-tags/cell-editor-vendor-tags.component';
import { GridAiComponent } from './grid-ai/grid-ai.component';
import { ActionsCellComponent } from './cell/actions-cell/actions-cell.component';
import { FilterFromFileDialogComponent } from './dialogs/filter-from-file-dialog/filter-from-file-dialog.component';
import { CellEditorRelatedPartsComponent } from './cell-editors/cell-editor-related-parts/cell-editor-related-parts.component';
import { AiPromptDialogComponent } from './dialogs/ai-prompt-dialog/ai-prompt-dialog.component';
import { AiSettingsDialogComponent } from './dialogs/ai-settings-dialog/ai-settings-dialog.component';
import {MatBadgeModule} from '@angular/material/badge';
import { AiFuntionDialogComponent } from './dialogs/ai-funtion-dialog/ai-funtion-dialog.component';
import { AiFunctionDialogComponent } from './dialogs/ai-function-dialog/ai-function-dialog.component';
import { GptResultsCellComponent } from './cell/gpt-results-cell/gpt-results-cell.component';
import { GptStepsCellComponent } from './cell/gpt-steps-cell/gpt-steps-cell.component';
import { AiStepTooltipComponent } from './components/ai-step-tooltip/ai-step-tooltip.component';
import { AiStepDetailsDialogComponent } from './dialogs/ai-step-details-dialog/ai-step-details-dialog.component';
import { AiTreeDataDialogComponent } from './dialogs/ai-tree-data-dialog/ai-tree-data-dialog.component';
import { GridAiTreeComponent } from './grid-ai-tree/grid-ai-tree.component';
import { AiCategoryCellComponent } from './cell/ai-category-cell/ai-category-cell.component';
import { AiTreeProductComponent } from './cell/ai-tree-product/ai-tree-product.component';
import { AiParserCellComponent } from './cell/ai-parser-cell/ai-parser-cell.component';
import { GridFineTuningComponent } from './grid-fine-tuning/grid-fine-tuning.component';
import { AiPushToLearnModelComponent } from './cell/ai-push-to-learn-model/ai-push-to-learn-model.component';
import { AiLearnDataActionsComponent } from './cell/ai-learn-data-actions/ai-learn-data-actions.component';
import { AiFineTuneGptActionsComponent } from './cell/ai-fine-tune-gpt-actions/ai-fine-tune-gpt-actions.component';
import { AiTuneSettingsDialogComponent } from './dialogs/ai-tune-settings-dialog/ai-tune-settings-dialog.component';
import { OldStructureCellComponent } from './cell/old-structure-cell/old-structure-cell.component';
import { AiStructureCellComponent } from './cell/ai-structure-cell/ai-structure-cell.component';
import { GridCollectionsComponent } from './grid-collections/grid-collections.component';
import { AiTitleCellRendererComponent } from './cell/ai-title-cell-renderer/ai-title-cell-renderer.component';
import { ScheduleExportDialogComponent } from './dialogs/schedule-export-dialog/schedule-export-dialog.component';

// LicenseManager.setLicenseKey('ag-Grid_Evaluation_License_Not_for_Production_100Devs30_August_2037__MjU4ODczMzg3NzkyMg==9e93ed5f03b0620b142770f2594a23a2');
// LicenseManager.setLicenseKey('Using_this_AG_Grid_Enterprise_key_( AG-044100 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Blackhawk Supply )_is_granted_a_( Single Application )_Developer_License_for_the_application_( BHS-WebDB )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( BHS-WebDB )_need_to_be_licensed___( BHS-WebDB )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 22 June 2024 )____[v2]_MTcxOTAxMDgwMDAwMA==124785e0b160478f9fc014432a82947d');
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-058134}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Blackhawk_Supply}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BHS-WebDB}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{BHS-WebDB}_need_to_be_licensed___{BHS-WebDB}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_June_2025}____[v3]_[01]_MTc1MDU0NjgwMDAwMA==d495b0ad43355f353bdf76800495f5ba');

@NgModule({
  declarations: [
    GridComponent,
    ObsoleteComponent,
    FeedComponent,
    ExpressionsBuilderDialogComponent,
    CellEditorBrandComponent,
    CellEditorTypeComponent,
    CellEditorTagsComponent,
    CellEditorAsmTagsComponent,
    BulkEditDialogComponent,
    ExportDiaglogComponent,
    ImportDiaglogComponent,
    // ProgressBarsComponent,
    FeedToolPanelComponent,
    GridLogsComponent,
    LogsToolPanelComponent,
    ConfirmationCellComponent,
    GridProductionComponent,
    GridHistoryComponent,
    DateComponentComponent,
    HistoryDialogComponent,
    CellHistoryRestoreButtonComponent,
    SkuComponent,
    AdminToolPanelComponent,
    TagsFilterComponent,
    GridDuplicatesComponent,
    CellEditorShippingTagsComponent,
    CellEditorRelatedProductsComponent,
    CellEditorDatasheetComponent,
    StatusCellComponent,
    UserManagementComponent,
    GridDeleteProductsComponent,
    TagsCustomFilterComponent,
    CellEditorVendorTagsComponent,
    GridAiComponent,
    ActionsCellComponent,
    FilterFromFileDialogComponent,
    CellEditorRelatedPartsComponent,
    AiPromptDialogComponent,
    AiSettingsDialogComponent,
    AiFuntionDialogComponent,
    AiFunctionDialogComponent,
    GptResultsCellComponent,
    GptStepsCellComponent,
    AiStepTooltipComponent,
    AiStepDetailsDialogComponent,
    AiTreeDataDialogComponent,
    GridAiTreeComponent,
    AiCategoryCellComponent,
    AiTreeProductComponent,
    AiParserCellComponent,
    GridFineTuningComponent,
    AiPushToLearnModelComponent,
    AiLearnDataActionsComponent,
    AiFineTuneGptActionsComponent,
    AiTuneSettingsDialogComponent,
    OldStructureCellComponent,
    AiStructureCellComponent,
    GridCollectionsComponent,
    AiTitleCellRendererComponent,
    ScheduleExportDialogComponent
  ],
  imports: [
    CommonModule,
    GridRoutingModule,
    CodemirrorModule,
    SharedModule,
    AgGridModule,
    MatDividerModule,
    MatTreeModule,
    MatRippleModule,
    MatBadgeModule,
  ],
  exports: [
    // ProgressBarsComponent
    UserManagementComponent
  ],
  entryComponents: [
    ProgressBarsComponent
  ]
})
export class GridModule { }
